import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrl: './dropzone.component.scss',
  standalone: true,
  imports: [NgClass, MatIcon, TranslateModule]
})
export class DropzoneComponent {
  @Input() enabled = true;

  draggingOver = false;

  @ViewChild('fileInput') fileInput?: ElementRef;
  @Output() fileChanged = new EventEmitter();

  onFileChange(event: Event) {
    this.fileChanged.emit(event);
  }

  onDrop() {
    this.draggingOver = false;
  }

  onDragOver() {
    if (this.enabled) {
      this.draggingOver = true;
    }
  }

  onAnchorClick(event: MouseEvent) {
    event.preventDefault();

    if (this.enabled) {
      this.fileInput?.nativeElement.click();
    }

    return false;
  }

  clearFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
}
